// source: pbtypes/gen/structure/geometry.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_structure_box_pb = require('../../../pbtypes/gen/structure/box_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_box_pb);
var pbtypes_gen_structure_cylinder_pb = require('../../../pbtypes/gen/structure/cylinder_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_cylinder_pb);
var pbtypes_gen_structure_geometry_type_pb = require('../../../pbtypes/gen/structure/geometry_type_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_geometry_type_pb);
goog.exportSymbol('proto.structure.Geometry', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.structure.Geometry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.structure.Geometry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.structure.Geometry.displayName = 'proto.structure.Geometry';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.structure.Geometry.prototype.toObject = function(opt_includeInstance) {
  return proto.structure.Geometry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.structure.Geometry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.Geometry.toObject = function(includeInstance, msg) {
  var f, obj = {
geometryType: jspb.Message.getFieldWithDefault(msg, 3, 0),
box: (f = msg.getBox()) && pbtypes_gen_structure_box_pb.Box.toObject(includeInstance, f),
cylinder: (f = msg.getCylinder()) && pbtypes_gen_structure_cylinder_pb.Cylinder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.structure.Geometry}
 */
proto.structure.Geometry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.structure.Geometry;
  return proto.structure.Geometry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.structure.Geometry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.structure.Geometry}
 */
proto.structure.Geometry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {!proto.structure.GeometryType.Enum} */ (reader.readEnum());
      msg.setGeometryType(value);
      break;
    case 1:
      var value = new pbtypes_gen_structure_box_pb.Box;
      reader.readMessage(value,pbtypes_gen_structure_box_pb.Box.deserializeBinaryFromReader);
      msg.setBox(value);
      break;
    case 2:
      var value = new pbtypes_gen_structure_cylinder_pb.Cylinder;
      reader.readMessage(value,pbtypes_gen_structure_cylinder_pb.Cylinder.deserializeBinaryFromReader);
      msg.setCylinder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.structure.Geometry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.structure.Geometry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.structure.Geometry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.structure.Geometry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGeometryType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getBox();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_structure_box_pb.Box.serializeBinaryToWriter
    );
  }
  f = message.getCylinder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_structure_cylinder_pb.Cylinder.serializeBinaryToWriter
    );
  }
};


/**
 * optional GeometryType.Enum geometry_type = 3;
 * @return {!proto.structure.GeometryType.Enum}
 */
proto.structure.Geometry.prototype.getGeometryType = function() {
  return /** @type {!proto.structure.GeometryType.Enum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.structure.GeometryType.Enum} value
 * @return {!proto.structure.Geometry} returns this
 */
proto.structure.Geometry.prototype.setGeometryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional Box box = 1;
 * @return {?proto.structure.Box}
 */
proto.structure.Geometry.prototype.getBox = function() {
  return /** @type{?proto.structure.Box} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_structure_box_pb.Box, 1));
};


/**
 * @param {?proto.structure.Box|undefined} value
 * @return {!proto.structure.Geometry} returns this
*/
proto.structure.Geometry.prototype.setBox = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.Geometry} returns this
 */
proto.structure.Geometry.prototype.clearBox = function() {
  return this.setBox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.Geometry.prototype.hasBox = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Cylinder cylinder = 2;
 * @return {?proto.structure.Cylinder}
 */
proto.structure.Geometry.prototype.getCylinder = function() {
  return /** @type{?proto.structure.Cylinder} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_structure_cylinder_pb.Cylinder, 2));
};


/**
 * @param {?proto.structure.Cylinder|undefined} value
 * @return {!proto.structure.Geometry} returns this
*/
proto.structure.Geometry.prototype.setCylinder = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.structure.Geometry} returns this
 */
proto.structure.Geometry.prototype.clearCylinder = function() {
  return this.setCylinder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.structure.Geometry.prototype.hasCylinder = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.structure);
